import { getEventLabel } from '@odo/shared-ui';

// Share of a total for bar widths, unrounded so a bar's segments always add up to 100.
export function shareOf(count: number, total: number): number {
    return total > 0 ? (count / total) * 100 : 0;
}

export function formatPercent(count: number, total: number): string {
    return `${Math.round(shareOf(count, total))}%`;
}

export function sumCounts(items: readonly { count: number }[]): number {
    return items.reduce((sum, item) => sum + item.count, 0);
}

const ACRONYM = /^[A-Z0-9]{2,}$/;

function toSentenceCase(text: string): string {
    return text
        .split(/\s+/)
        .filter(Boolean)
        .map((word, index) => {
            if (ACRONYM.test(word)) return word;
            const lower = word.toLowerCase();
            return index === 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
        })
        .join(' ');
}

function splitPascalCase(text: string): string {
    return text.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
}

// Known DM types use the inbox's labels; unknown ones are split from PascalCase.
export function eventTypeLabel(eventType: string): string {
    const known = getEventLabel(eventType);
    return toSentenceCase(known === eventType ? splitPascalCase(eventType) : known);
}
